import axios from 'axios';

const axiosAgent = axios.create({
  baseURL: process.env.VUE_APP_COUPON_BASEURL,
  withCredentials: true,
});

axiosAgent.interceptors.response.use((res) => res.data);

export default axiosAgent;
